module.exports = __webpack_public_path__ + "static/media/idcard.f782d089.png";